module.exports = __webpack_public_path__ + "static/fonts/Roboto900italic.18a576bf.ttf";